import React from 'react';
import { QuestionBlock } from '../types';
import BEM from 'common/bem';

const classes = BEM.with('QuestionPrompt');

type QuestionPromptProps = {
  data: QuestionBlock;
  onSelect: (value: string, label?: string) => void;
  disabled?: boolean;
};

export default function QuestionPrompt({ data, onSelect, disabled }: QuestionPromptProps) {
  const hasOptions = data.questionType !== 'free_text' && data.options && data.options.length > 0;

  return (
    <div className={classes()}>
      <p className={classes('prompt')}>
        <svg
          className={classes('prompt-icon')}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
        {data.prompt}
      </p>
      {hasOptions && (
        <div className={classes('options')}>
          {(data.options ?? []).map((option) => (
            <button
              key={option.value}
              className={classes('option-btn')}
              onClick={() => onSelect(option.value, option.label)}
              disabled={disabled}
              type="button"
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
